import * as Types from '../../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type InsuranceProvidersQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type InsuranceProvidersQuery = { readonly __typename?: 'Query', readonly minInsuranceProviders: ReadonlyArray<{ readonly __typename?: 'MinInsuranceProvider', readonly id: string, readonly name?: string | null, readonly insuranceType?: string | null, readonly properties?: ReadonlyArray<unknown | null> | null } | null> };


export const InsuranceProvidersDocument = gql`
    query InsuranceProviders {
  minInsuranceProviders {
    id
    name
    insuranceType
    properties
  }
}
    `;

/**
 * __useInsuranceProvidersQuery__
 *
 * To run a query within a React component, call `useInsuranceProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuranceProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuranceProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsuranceProvidersQuery(baseOptions?: Apollo.QueryHookOptions<InsuranceProvidersQuery, InsuranceProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InsuranceProvidersQuery, InsuranceProvidersQueryVariables>(InsuranceProvidersDocument, options);
      }
export function useInsuranceProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InsuranceProvidersQuery, InsuranceProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InsuranceProvidersQuery, InsuranceProvidersQueryVariables>(InsuranceProvidersDocument, options);
        }
export type InsuranceProvidersQueryHookResult = ReturnType<typeof useInsuranceProvidersQuery>;
export type InsuranceProvidersLazyQueryHookResult = ReturnType<typeof useInsuranceProvidersLazyQuery>;
export type InsuranceProvidersQueryResult = Apollo.QueryResult<InsuranceProvidersQuery, InsuranceProvidersQueryVariables>;